<div class="jumbotron">
  <h1 class="display-4 text-center">Logoff Successful</h1>
  <p class="lead text-center">You have successfully logged out.</p>
  <hr class="my-4">
  <p class="lead text-center">
    <a class="btn btn-primary btn-lg" href="#" role="button" (click)="login()">Login Again?</a>
  </p>
</div>
